import React, { useState, useCallback, useEffect, memo } from 'react'
import DraggableListItem from './DraggableListItem'
import Box from '@mui/material/Box'
import { StrictModeDroppable } from './StrictModeDroppable'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

const List = ({
  items,
  mostLabel,
  leastLabel,
}) => {

  return (
    <Box
      sx={{
        maxWidth: 260,
        display: "grid",
        gap: 1.5,
        gridTemplateColumns: "1fr",
        '@media (min-width: 768px)': {
          maxWidth: 400,
        },
      }}
    >



      <StrictModeDroppable droppableId="question-3" direction="vertical">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            <Stack
              display="inline-grid"
              alignItems="center"
            >
              <Typography variant="labelUpper" sx={(theme)=>({mb: 1})}>{mostLabel}</Typography>
              {items.map((o, index) => (
                <DraggableListItem
                  key={o.text}
                  index={index}
                  text={o.text}
                  draggableIndex={o.dragId}
                />
              ))}
              {provided.placeholder}
              <Typography variant="labelUpper" sx={(theme)=>({mt: 1})}>{leastLabel}</Typography>
            </Stack>
          </div>
        )}
      </StrictModeDroppable>
    </Box>
  );
}

export default memo(List)